import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=acff5128&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=acff5128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acff5128",
  null
  
)

export default component.exports